/** Oturum içi: şikayet eden kullanıcı forum listesinde bu gönderileri görmez. */
const locallyHiddenForumPostIds = new Set<string>();

const listeners = new Set<() => void>();

/** Liste / ana sayfa gibi bileşenler Set değişince yeniden filtrelensin diye abone olur. */
export function subscribeForumLocalHideChanges(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function hideForumPostLocallyForReporter(postId: string): void {
  if (locallyHiddenForumPostIds.has(postId)) {
    return;
  }
  locallyHiddenForumPostIds.add(postId);
  listeners.forEach(l => {
    l();
  });
}

export function isForumPostLocallyHidden(postId: string): boolean {
  return locallyHiddenForumPostIds.has(postId);
}
